<template>
  <!-- template have only one root node -->
  <div :class="`component conectionlessWrap ${isNight ? 'conectionlessWrap_dark' : ''}`">
    <img :src="imgUrl" class="connectionless" />
    <!-- change Chinese to English -->
    <div class="tip">{{ tip || $t('request.tapTopRetry') }}</div>
    <slot></slot>
  </div>
</template>
<style scoped lang="stylus">
.conectionlessWrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.connectionless {
  width: 10.8rem;
  height: 5.4rem;
}

.tip {
  width: 9.36rem;
  // margin-top: 0.36rem;
  line-height: 0.63rem;
  font-size: 0.48rem;
  color: rgba(0, 0, 0, 0.3);
  text-align: center;
}

.conectionlessWrap_dark {
  .tip {
    color: rgba(255, 255, 255, 0.3);
  }
}
</style>
<script>
import nothingImg from './nothing.webp'
import nothingDarkImg from './nothing_dark.webp'
import noInternetImg from './noInternetImg.svg'
// import noInternetImg from './noInternet.webp'
import noInternetDarkImg from './noInternet_dark.webp'

export default {
  props: ['tip', 'isNight', 'isInternet'],
  computed: {
    imgUrl() {
      if (!this.isInternet) {
        if (this.isNight) {
          return nothingDarkImg
        }
          return nothingImg     
      }else{
        if (this.isNight) {
          return noInternetDarkImg
        }
          return noInternetImg     
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/connectionless/index.vue